module.exports = __webpack_public_path__ + "static/img/4.49d9dd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/4.png
// module id = LfR3
// module chunks = 0